import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useWorkSession } from '../context/WorkSessionContext';
import './Navbar.css';

export default function Navbar() {
  const { currentUser, logout } = useAuth();
  const { isAdmin, isChemist } = useWorkSession();
  const location = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);

  const isActive = (path) => location.pathname === path || location.pathname.startsWith(path + '/');

  return (
    <nav className="navbar">
      <div className="navbar-inner">
        <Link to="/" className="navbar-brand">
          <span className="navbar-brand-icon">⚗️</span>
          <span className="navbar-brand-text">
            <span className="brand-main">Wohler</span>
            <span className="brand-sub">.chemical</span>
          </span>
          <span className="navbar-brand-badge">Research Portal</span>
        </Link>

        <div className={`navbar-links ${menuOpen ? 'open' : ''}`}>
          <Link to="/" className={`nav-link ${location.pathname === '/' ? 'active' : ''}`} onClick={() => setMenuOpen(false)}>
            Home
          </Link>
          <Link to="/compounds" className={`nav-link ${isActive('/compounds') ? 'active' : ''}`} onClick={() => setMenuOpen(false)}>
            Compounds
          </Link>
          <Link to="/categories" className={`nav-link ${isActive('/categories') ? 'active' : ''}`} onClick={() => setMenuOpen(false)}>
            Categories
          </Link>
          <Link to="/journal" className={`nav-link ${isActive('/journal') ? 'active' : ''}`} onClick={() => setMenuOpen(false)}>
            📓 Journal
          </Link>
          <Link to="/about" className={`nav-link ${isActive('/about') ? 'active' : ''}`} onClick={() => setMenuOpen(false)}>
            About
          </Link>
          <Link to="/admin" className={`nav-link ${isActive('/admin') ? 'active' : ''}`} onClick={() => setMenuOpen(false)} style={{ borderLeft: '1px solid rgba(99,102,241,0.2)', paddingLeft: '16px', marginLeft: '4px' }}>
            ⚙️ Data
          </Link>
          {isAdmin && (
            <Link to="/dashboard" className={`nav-link ${isActive('/dashboard') ? 'active' : ''}`} onClick={() => setMenuOpen(false)} style={{ color: '#818cf8' }}>
              📊 Dashboard
            </Link>
          )}
          {isChemist && (
            <span className="nav-link nav-chemist-badge" title="You are logged in as Chemist">
              🧪 Chemist
            </span>
          )}
        </div>

        <div className="navbar-right">
          {currentUser && (
            <>
              <span className="navbar-user">
                <span className="navbar-user-dot" />
                {currentUser.email}
              </span>
              <button className="navbar-logout" onClick={logout}>
                Sign Out
              </button>
            </>
          )}
          <button className="navbar-hamburger" onClick={() => setMenuOpen(!menuOpen)} aria-label="Menu">
            <span /><span /><span />
          </button>
        </div>
      </div>

      <div className="navbar-disclaimer-bar">
        <span className="disclaimer-icon">⚠️</span>
        <span>Research Use Only — Not for Human Consumption — Authorized Researchers Only</span>
      </div>
    </nav>
  );
}